// ----------------------------------------------------------------------
function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '';
const ROOTS_DASHBOARD = '';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  resetConfirmPassword: path(ROOTS_AUTH, '/reset-confirm-password'),
  verify: path(ROOTS_AUTH, '/verify'),
  userDone: path(ROOTS_AUTH, '/user-done'),
};
export const PATH_PROFILE = {
  locationsDetails: ROOTS_DASHBOARD,
  prevProj: path(ROOTS_AUTH, '/project-preview'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    profile: path(ROOTS_DASHBOARD, '/profile'),
  },
  app: path(ROOTS_DASHBOARD, '/dashboard'),
  setting: path(ROOTS_DASHBOARD, '/setting'),
  myContact: path(ROOTS_DASHBOARD, '/contacts'),
  calendar: path(ROOTS_DASHBOARD, '/calendar'),

  inBox: {
    root: path(ROOTS_DASHBOARD, '/inbox'),
    inbox: path(ROOTS_DASHBOARD, '/inbox/inbox'),
    notification: path(ROOTS_DASHBOARD, '/inbox/notification'),
    enquiry: path(ROOTS_DASHBOARD, '/inbox/enquiry'),
  },
  subscription: path(ROOTS_DASHBOARD, '/subscription'),
  website: path(ROOTS_DASHBOARD, '/website'),
  networking: path(ROOTS_DASHBOARD, '/networking'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  jobs: {
    root: path(ROOTS_DASHBOARD, '/jobs'),
    postings: path(ROOTS_DASHBOARD, '/jobs/postings'),
    create: path(ROOTS_DASHBOARD, '/jobs/create'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/personal-info'),
  },
  search: {
    root: path(ROOTS_DASHBOARD, '/search'),
    talentSearch: path(ROOTS_DASHBOARD, '/search/talentSearch'),
    talentSearchResult: path(ROOTS_DASHBOARD, '/search/talentSearchResult'),
    talentSearchMain: path(ROOTS_DASHBOARD, '/search/talentSearchMain'),
  },
  connectnetwork: {
    root: path(ROOTS_DASHBOARD, '/network'),
    followers: path(ROOTS_DASHBOARD, '/network/followers'),
    following: path(ROOTS_DASHBOARD, '/network/following'),
    mynetwork: path(ROOTS_DASHBOARD, '/network/mynetwork'),
    myinvitation: path(ROOTS_DASHBOARD, '/network/myinvitation'),
    network: path(ROOTS_DASHBOARD, '/network/network'),

  },
  
};

export const PATH_JOBS = {
  root: path(ROOTS_DASHBOARD, '/jobs'),
  
};
export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
